class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.form.addEventListener('submit', this.onSearchSubmit.bind(this));
      this.input.form.addEventListener('formdata', (event) => {
        event.formData.set('q', SearchForm.searchQuery(this.input.value));
      });
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }
  }

  static normalizeQuery(query) {
    const term = query.trim();
    if (/[:()"*]/.test(term) || /\b(?:AND|OR|NOT)\b/.test(term)) return term;
    const aliases = [["sausage dogs","Dachshund"],["sausage dog","Dachshund"],["worktop protectors","worktop saver"],["worktop protector","worktop saver"],["worktop savers","worktop saver"],["cutting boards","worktop saver"],["cutting board","worktop saver"],["choppingboards","worktop saver"],["choppingboard","worktop saver"],["choping boards","worktop saver"],["choping board","worktop saver"],["chopping bord","worktop saver"],["byrddau torri","worktop saver"],["bwrdd torri","worktop saver"],["matiau diod","coasters"],["mat diod","coaster"],["cardiau pen-blwydd","birthday cards"],["cerdyn pen-blwydd","birthday card"],["cardiau penblwydd","birthday cards"],["cerdyn penblwydd","birthday card"],["labrodor","Labrador"],["labradore","Labrador"],["dachsund","Dachshund"],["daschund","Dachshund"],["dachund","Dachshund"],["highlandcow","Highland Cow"],["costers","coasters"],["anrhegion","gifts"],["anrheg","gift"],["ddraig","dragon"],["draig","dragon"],["defaid","sheep"],["ddafad","sheep"],["dafad","sheep"],["cŵn","dog"],["cwn","dog"],["ci","dog"],["cathod","cat"],["cath","cat"],["ceffylau","horse"],["ceffyl","horse"],["buchod","cow"],["buwch","cow"],["cardiau","cards"],["cerdyn","card"],["cymru","Welsh"],["cymraeg","Welsh"],["chopping boards","worktop saver"],["chopping board","worktop saver"]];
    let normalized = term.replace(/\s+/g, ' ');
    for (const [alias, canonical] of aliases) {
      const pattern = new RegExp('(^|\\s)' + alias + '(?=\\s|$)', 'giu');
      normalized = normalized.replace(pattern, (_, separator) => separator + canonical);
    }
    if (/^(lab|labs)$/i.test(normalized) || /\b(cards?|gifts?|coasters?|boards?|placemats?|bags?|bottles?)\b/i.test(normalized)) {
      normalized = normalized.replace(/(^|\s)labs?(?=\s|$)/gi, (_, separator) => separator + 'Labrador');
    }
    return normalized;
  }

  static searchQuery(query) {
    const normalized = SearchForm.normalizeQuery(query);
    if (/[:()"*]/.test(normalized) || /\b(?:AND|OR|NOT)\b/.test(normalized)) return normalized;
    return normalized.replace(/\b(black|chocolate|brown|golden|yellow|red fox)\s+labradors?\b/gi, (phrase) =>
      'title:"' + phrase.toLowerCase().replace(/labradors$/, 'labrador') + '"'
    );
  }

  onSearchSubmit(event) {
    if (event.defaultPrevented || this.querySelector('[aria-selected="true"] a')) return;
    this.input.value = SearchForm.normalizeQuery(this.input.value);
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);
